import { NgModule } from '@angular/core';

import { LayoutComponent } from './layout.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { HeaderComponent } from './header/header.component';
import { NavsearchComponent } from './header/navsearch/navsearch.component';
import { UserblockComponent } from './sidebar/userblock/userblock.component';
import { UserblockService } from './sidebar/userblock/userblock.service';
import { FooterComponent } from './footer/footer.component';

import { NodeSidebarComponent } from './nodesidebar/nodesidebar.component';

import { DrawerModule } from '@progress/kendo-angular-layout';
import { PopupModule } from '@progress/kendo-angular-popup';

import { SharedModule } from '../shared/shared.module';
import { TagInputModule } from 'ngx-chips';
import { RightPanelComponent } from './right-panel/right-panel.component';

@NgModule({
  imports: [
        TagInputModule,
        SharedModule,
        // CHAT-857: the sidebar renderer. Drawer for the rail + items, Popup for the
        // collapsed-rail flyout that replaced the jQuery `.nav-floating` clone.
        DrawerModule,
        PopupModule,
        RightPanelComponent
    ],
    providers: [
        UserblockService
    ],
    declarations: [
        LayoutComponent,
        NodeSidebarComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        FooterComponent
    ],
    exports: [
        LayoutComponent,
        NodeSidebarComponent,
        SidebarComponent,
        UserblockComponent,
        HeaderComponent,
        NavsearchComponent,
        FooterComponent
    ]
})
export class LayoutModule { }
